__turbopack_context__.v({
  "component": "Earu-G_component",
  "component__block": "Earu-G_component__block",
  "component__blockBtn": "Earu-G_component__blockBtn",
  "component__blockContent": "Earu-G_component__blockContent",
  "component__blockTitle": "Earu-G_component__blockTitle",
  "component__blocks": "Earu-G_component__blocks",
  "component__body": "Earu-G_component__body",
  "component__close": "Earu-G_component__close",
  "component__contentWrapper": "Earu-G_component__contentWrapper",
  "component__header": "Earu-G_component__header",
  "component__modalContainer": "Earu-G_component__modalContainer",
  "component__subtitle": "Earu-G_component__subtitle",
  "component__title": "Earu-G_component__title",
  "hide-for-large": "Earu-G_hide-for-large",
  "hide-for-large-only": "Earu-G_hide-for-large-only",
  "hide-for-medium": "Earu-G_hide-for-medium",
  "hide-for-medium-only": "Earu-G_hide-for-medium-only",
  "hide-for-small-only": "Earu-G_hide-for-small-only",
  "show-for-large": "Earu-G_show-for-large",
  "show-for-large-only": "Earu-G_show-for-large-only",
  "show-for-medium": "Earu-G_show-for-medium",
  "show-for-medium-only": "Earu-G_show-for-medium-only",
  "show-for-small-only": "Earu-G_show-for-small-only",
  "u-color-black": "Earu-G_u-color-black",
  "u-color-blue": "Earu-G_u-color-blue",
  "u-color-midnight": "Earu-G_u-color-midnight",
  "u-color-primary-dark": "Earu-G_u-color-primary-dark",
  "u-color-red": "Earu-G_u-color-red",
  "u-color-white": "Earu-G_u-color-white",
  "u-theme-black": "Earu-G_u-theme-black",
  "u-theme-blue": "Earu-G_u-theme-blue",
  "u-theme-dark": "Earu-G_u-theme-dark",
  "u-theme-light": "Earu-G_u-theme-light",
  "u-theme-red": "Earu-G_u-theme-red",
  "u-theme-white": "Earu-G_u-theme-white",
});
